




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestQuestion from "@/store/entities/testQuestion";
import url from "@/lib/url";
import ewebeditor from "@/components/ewebeditor.vue";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";
import RepeatTestQuestion from "./repeat-testQuestion.vue";
@Component({
  components: { ewebeditor, RepeatTestQuestion },
})
export default class EditSisterQuestion extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  testQuestionsister: TestQuestion = new TestQuestion();
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  formTitle: string = "新增姊妹题";
  editorConfig: any = {
    style: "mini",
    width: "100%",
    height: "100px",
  };
  editorContentConfig: any = {
    style: "coolblue",
    width: "100%",
    height: "300px",
  };
  frontendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  editorBackendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  repeatModalShow: boolean = false;
  keywords: string = "";
  topicData: any = [];
  isCreate: boolean = true;
  data: any = [];
  valueArray: any = [];
  onequestype: string = "";
  parentId?: number;
  screenWidth: number = document.body.clientWidth - 200;
  parentName: string = "一级分类";
  isAudit: any = [
    { id: "true", value: "通过审核" },
    { id: "false", value: "未通过审核" },
  ];
  pdu: any = [
    { id: "True", value: "正确" },
    { id: "False", value: "错误" },
  ];
  difficultNamevar: any = [
    { id: 1, value: "易(A)" },
    { id: 2, value: "中(B)" },
    { id: 3, value: "难(C)" },
  ];
  blanksnum: number = 1;
  choicenum: number = 1;
  blanksnumdata: any = [
    //填空
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
    { id: 3, value: "15项" },
  ];
  choicenumdata: any = [
    //单选
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
  ];
  newtabdata: any = [
    { id: 0, value: "判断题" },
    { id: 1, value: "单选题" },
    { id: 2, value: "多选题" },
    { id: 3, value: "填空题" },
    { id: 4, value: "计算题" },
    { id: 8, value: "解答题" },
    { id: 9, value: "作文题" },
    { id: 10, value: "探究题" },
    { id: 11, value: "材料题" },
    { id: 12, value: "实践题" },
    { id: 7, value: "选考单选" },
    { id: 5, value: "选考多选" },
    { id: 6, value: "选考计算" },
  ];

  keytype: string = "";
  keychecktype: any = [];

  questionTypeChange(value) {
    this.choicenum = 1;
    this.blanksnum = 1;
    this.testQuestionsister.questionType = value;
  }
  removefilterHtmlbr(value) {
    let content = value
      .replace(/^(<[Bb][Rr]*?.*?\/?\s*?>)+/, "")
      .replace(/(<[Bb][Rr]*?.*?\/?\s*?>)+$/g, "");
    return content;
  }

  choicenumChange(value) {
    this.choicenum = value;
    if (value == 2) {
      (this.$refs["answerKeyFsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyGsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyHsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyIsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyJsister"] as any).setHtmlewebQuesTion("");
    }
  }
  blanksnumChange(value) {
    this.blanksnum = value;
    if (value == 2) {
      (this.$refs["answerKeyFsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyGsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyHsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyIsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyJsister"] as any).setHtmlewebQuesTion("");
    }
    if (value < 2) {
      (this.$refs["answerKeyKsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyLsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyMsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyNsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyOsister"] as any).setHtmlewebQuesTion("");
    }
  }
  topicOne: any = [];
  topicTwo: any = [];
  uploadActin: string = url + "api/services/app/File/FileGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  questionContentsister: string = "";
  answerTipssister: string = "";
  answerKeyAsister: string = "";
  answerKeyBsister: string = "";
  answerKeyCsister: string = "";
  answerKeyDsister: string = "";
  answerKeyEsister: string = "";
  answerKeyFsister: string = "";
  answerKeyGsister: string = "";
  answerKeyHsister: string = "";
  answerKeyIsister: string = "";
  answerKeyJsister: string = "";
  answerKeyKsister: string = "";
  answerKeyLsister: string = "";
  answerKeyMsister: string = "";
  answerKeyNsister: string = "";
  answerKeyOsister: string = "";
  uploadSuccess(res, file, fileList) {
    this.uploadList = fileList;
  }

  searchebutcount() {
    if (!this.keywords) {
      this.$Message.error("请输入试题内容");
      return false;
    }
    if (
      !this.testQuestionsister.questionType &&
      this.testQuestionsister.questionType !== 0
    ) {
      this.$Message.error("请选择试题类型");
      return false;
    }
    this.$store.state.testQuestion.sisterInfoTestQuestion.questionType = this.testQuestionsister.questionType;
    this.$store.state.testQuestionsister.sisterInfoTestQuestion.keyword = this.keywords;
    this.repeatModalShow = true;
  }
  setEditorData_a() {
    (this.$refs["deconmesister"] as any).setHtmlewebQuesTion(
      this.questionContentsister,
    );
  }
  setEditorData_b() {
    (this.$refs["answerKeyAsister"] as any).setHtmlewebQuesTion(
      this.answerKeyAsister,
    );
  }
  setEditorData_c() {
    (this.$refs["answerKeyBsister"] as any).setHtmlewebQuesTion(
      this.answerKeyBsister,
    );
  }
  setEditorData_d() {
    (this.$refs["answerKeyCsister"] as any).setHtmlewebQuesTion(
      this.answerKeyCsister,
    );
  }
  setEditorData_e() {
    (this.$refs["answerKeyDsister"] as any).setHtmlewebQuesTion(
      this.answerKeyDsister,
    );
  }
  setEditorData_f() {
    (this.$refs["answerKeyEsister"] as any).setHtmlewebQuesTion(
      this.answerKeyEsister,
    );
  }
  setEditorData_h() {
    if (this.testQuestionsister.answerKeyF) {
      setTimeout(() => {
        (this.$refs["answerKeyFsister"] as any).setHtmlewebQuesTion(
          this.answerKeyFsister,
        );
      }, 500);
    }
  }

  setEditorData_i() {
    if (this.testQuestionsister.answerKeyG) {
      setTimeout(() => {
        (this.$refs["answerKeyGsister"] as any).setHtmlewebQuesTion(
          this.answerKeyGsister,
        );
      }, 500);
    }
  }
  setEditorData_j() {
    if (this.testQuestionsister.answerKeyH) {
      setTimeout(() => {
        (this.$refs["answerKeyHsister"] as any).setHtmlewebQuesTion(
          this.answerKeyHsister,
        );
      }, 500);
    }
  }
  setEditorData_k() {
    if (this.testQuestionsister.answerKeyI) {
      setTimeout(() => {
        (this.$refs["answerKeyIsister"] as any).setHtmlewebQuesTion(
          this.answerKeyIsister,
        );
      }, 500);
    }
  }
  setEditorData_l() {
    if (this.testQuestionsister.answerKeyJ) {
      setTimeout(() => {
        (this.$refs["answerKeyJsister"] as any).setHtmlewebQuesTion(
          this.answerKeyJsister,
        );
      }, 500);
    }
  }
  setEditorData_m() {
    if (this.testQuestionsister.answerKeyK) {
      setTimeout(() => {
        (this.$refs["answerKeyKsister"] as any).setHtmlewebQuesTion(
          this.answerKeyKsister,
        );
      }, 500);
    }
  }
  setEditorData_n() {
    if (this.testQuestionsister.answerKeyL) {
      setTimeout(() => {
        (this.$refs["answerKeyLsister"] as any).setHtmlewebQuesTion(
          this.answerKeyLsister,
        );
      }, 500);
    }
  }
  setEditorData_o() {
    if (this.testQuestionsister.answerKeyM) {
      setTimeout(() => {
        (this.$refs["answerKeyMsister"] as any).setHtmlewebQuesTion(
          this.answerKeyMsister,
        );
      }, 500);
    }
  }
  setEditorData_p() {
    if (this.testQuestionsister.answerKeyN) {
      setTimeout(() => {
        (this.$refs["answerKeyNsister"] as any).setHtmlewebQuesTion(
          this.answerKeyNsister,
        );
      }, 500);
    }
  }
  setEditorData_q() {
    if (this.testQuestionsister.answerKeyO) {
      setTimeout(() => {
        (this.$refs["answerKeyOsister"] as any).setHtmlewebQuesTion(
          this.answerKeyOsister,
        );
      }, 500);
    }
  }

  setEditorData_g() {
    (this.$refs["answerTipssister"] as any).setHtmlewebQuesTion(
      this.answerTipssister,
    );
  }

  setEditorDataInit() {
    (this.$refs["deconmesister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerTipssister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyAsister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyBsister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyCsister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyDsister"] as any).setHtmlewebQuesTion("");
    (this.$refs["answerKeyEsister"] as any).setHtmlewebQuesTion("");
    if (
      this.testQuestionsister.questionType == 1 ||
      this.testQuestionsister.questionType == 3
    ) {
      (this.$refs["answerKeyFsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyGsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyHsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyIsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyJsister"] as any).setHtmlewebQuesTion("");
    }
    if (this.testQuestionsister.questionType == 3) {
      (this.$refs["answerKeyKsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyLsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyMsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyNsister"] as any).setHtmlewebQuesTion("");
      (this.$refs["answerKeyOsister"] as any).setHtmlewebQuesTion("");
    }
  }
  getQuestionContent() {
    this.testQuestionsister.questionContent = this.removefilterHtmlbr(
      this.testQuestionsister.questionContent,
    );
    this.testQuestionsister.answerTips = this.removefilterHtmlbr(
      this.testQuestionsister.answerTips,
    );

    if (this.testQuestionsister.questionType > 0) {
      this.testQuestionsister.answerKeyA = this.removefilterHtmlbr(
        this.testQuestionsister.answerKeyA,
      );
      this.testQuestionsister.answerKeyB = this.removefilterHtmlbr(
        this.testQuestionsister.answerKeyB,
      );
      this.testQuestionsister.answerKeyC = this.removefilterHtmlbr(
        this.testQuestionsister.answerKeyC,
      );
      this.testQuestionsister.answerKeyD = this.removefilterHtmlbr(
        this.testQuestionsister.answerKeyD,
      );
      this.testQuestionsister.answerKeyE = this.removefilterHtmlbr(
        this.testQuestionsister.answerKeyE,
      );
    }
    if (
      this.testQuestionsister.questionType == 1 ||
      this.testQuestionsister.questionType == 3
    ) {
      if (this.blanksnum >= 2 || this.choicenum == 2) {
        this.testQuestionsister.answerKeyF = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyF,
        );
        this.testQuestionsister.answerKeyG = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyG,
        );
        this.testQuestionsister.answerKeyH = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyH,
        );
        this.testQuestionsister.answerKeyI = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyI,
        );
        this.testQuestionsister.answerKeyJ = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyJ,
        );
      }
    }
    if (this.testQuestionsister.questionType == 3) {
      if (this.blanksnum > 2) {
        this.testQuestionsister.answerKeyK = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyK,
        );
        this.testQuestionsister.answerKeyL = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyL,
        );
        this.testQuestionsister.answerKeyM = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyM,
        );
        this.testQuestionsister.answerKeyN = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyN,
        );
        this.testQuestionsister.answerKeyO = this.removefilterHtmlbr(
          this.testQuestionsister.answerKeyO,
        );
      }
    }
  }
  handleRemove(file, fileList) {
    this.uploadList = fileList;
  }
  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过50M.",
    });
  }
  search() {}
  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.testQuestionsister.sectionId =
        selectedData[selectedData.length - 1].id;
    else this.testQuestionsister.sectionId = null;
  }

  save() {
    (this.$refs.sisterQuestionForm as any).validate(async (valid: boolean) => {
      if (valid) {
        //console.log(this.valueArray);
        if (this.valueArray.length > 0) {
          if (this.valueArray.length < 4) {
            this.$Message.warning("学科未选择到末级!");
            return false;
          }
        } else {
          this.$Message.warning("请选择试题学科");
          return false;
        }
        if (!this.testQuestionsister.degreeDifficulty) {
          this.$Message.warning("请选择试题难度");
          return false;
        }
        if (
          !this.testQuestionsister.questionType &&
          this.testQuestionsister.questionType !== 0
        ) {
          this.$Message.warning("请选择试题类型");
          return false;
        }
        this.testQuestionsister.sectionId = this.valueArray[
          this.valueArray.length - 1
        ];
        this.getQuestionContent();
        if (
          this.testQuestionsister.questionType == 1 ||
          this.testQuestionsister.questionType == 2 ||
          this.testQuestionsister.questionType == 5 ||
          this.testQuestionsister.questionType == 7
        ) {
          if (
            this.testQuestionsister.questionType == 1 ||
            this.testQuestionsister.questionType == 7
          ) {
            this.testQuestionsister.correctAnswer = this.keytype;
          } else {
            this.testQuestionsister.correctAnswer = this.keychecktype.join(",");
          }
        } else {
          if (
            !this.testQuestionsister.answerKeyA &&
            this.testQuestionsister.questionType != 0
          ) {
            this.$Message.warning("至少有一个答案，并从第一个开始");
            return false;
          } else if (this.testQuestionsister.questionType == 0) {
            this.testQuestionsister.correctAnswer = this.onequestype;
          } else {
            this.testQuestionsister.correctAnswer = this.testQuestionsister.answerKeyA;
          }
          if (this.testQuestionsister.answerKeyB) {
            this.testQuestionsister.correctAnswer +=
              "\r\n" + this.testQuestionsister.answerKeyB;
          }
          if (this.testQuestionsister.answerKeyC) {
            this.testQuestionsister.correctAnswer +=
              "\r\n" + this.testQuestionsister.answerKeyC;
          }
          if (this.testQuestionsister.answerKeyD) {
            this.testQuestionsister.correctAnswer +=
              "\r\n" + this.testQuestionsister.answerKeyD;
          }
          if (this.testQuestionsister.answerKeyE) {
            this.testQuestionsister.correctAnswer +=
              "\r\n" + this.testQuestionsister.answerKeyE;
          }

          if (this.testQuestionsister.questionType == 3) {
            //填空题 正确答案后10空
            if (this.testQuestionsister.answerKeyF) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyF;
            }
            if (this.testQuestionsister.answerKeyG) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyG;
            }
            if (this.testQuestionsister.answerKeyH) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyH;
            }
            if (this.testQuestionsister.answerKeyI) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyI;
            }
            if (this.testQuestionsister.answerKeyJ) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyJ;
            }
            if (this.testQuestionsister.answerKeyK) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyK;
            }
            if (this.testQuestionsister.answerKeyL) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyL;
            }
            if (this.testQuestionsister.answerKeyM) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyM;
            }
            if (this.testQuestionsister.answerKeyN) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyN;
            }
            if (this.testQuestionsister.answerKeyO) {
              this.testQuestionsister.correctAnswer +=
                "\r\n" + this.testQuestionsister.answerKeyO;
            } //填空题 正确答案后10空
          }
        }
        if (!this.testQuestionsister.questionContent) {
          this.$Message.warning("请填写试题内容");
          return false;
        }
        if (
          !this.testQuestionsister.answerKeyA &&
          this.testQuestionsister.questionType
        ) {
          this.$Message.warning("请填写答案内容");
          return false;
        }
        if (this.testQuestionsister.questionType == 0) {
          if (!this.onequestype) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestionsister.questionType == 1 ||
          this.testQuestionsister.questionType == 2 ||
          this.testQuestionsister.questionType == 5 ||
          this.testQuestionsister.questionType == 7
        ) {
          if (
            !this.testQuestionsister.correctAnswer ||
            this.testQuestionsister.correctAnswer.length < 1
          ) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestionsister.questionType == 2 ||
          this.testQuestionsister.questionType == 5
        ) {
          if (this.testQuestionsister.correctAnswer.length < 3) {
            this.$Message.warning("请至少选择两个正确答案");
            return false;
          }
        }
        this.testQuestionsister.gradeType = 1;
        //this.testQuestion.isAudit = "true";
        let sendType = "testQuestion/create";
        if (!this.isCreate) {
          sendType = "testQuestion/update";
        }
        this.$store
          .dispatch({
            type: sendType,
            data: this.testQuestionsister,
          })
          .then((result) => {
            if (this.isCreate) {
              //  this.testQuestion.degreeDifficulty = 0;

              this.keytype = "";
              this.keychecktype = [];
              this.onequestype = "";
              (this.$refs["deconmesister"] as any).setHtmlewebQuesTion("");
              (this.$refs["answerTipssister"] as any).setHtmlewebQuesTion("");
              if (this.testQuestionsister.questionType > 0) {
                this.testQuestionsister.correctAnswer = "";
                this.testQuestionsister.answerKeyA = "";
                this.testQuestionsister.answerKeyB = "";
                this.testQuestionsister.answerKeyC = "";
                this.testQuestionsister.answerKeyD = "";
                this.testQuestionsister.answerKeyE = "";
                if (this.blanksnum >= 2 || this.choicenum == 2) {
                  this.testQuestionsister.answerKeyF = "";
                  this.testQuestionsister.answerKeyG = "";
                  this.testQuestionsister.answerKeyH = "";
                  this.testQuestionsister.answerKeyI = "";
                  this.testQuestionsister.answerKeyJ = "";
                }
                if (this.blanksnum > 2) {
                  this.testQuestionsister.answerKeyK = "";
                  this.testQuestionsister.answerKeyL = "";
                  this.testQuestionsister.answerKeyM = "";
                  this.testQuestionsister.answerKeyN = "";
                  this.testQuestionsister.answerKeyO = "";
                }
              } else {
                this.testQuestionsister.correctAnswer = "";
              }
              //  this.testQuestion.questionType = undefined;
            } else {
              this.testQuestionsister.correctAnswer = "";
              (this.$refs.sisterQuestionForm as any).resetFields();
              this.$emit("save-success");
              this.$emit("input", false);
            }
          });
      }
    });
  }

  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    this.choicenum = 1;
    this.blanksnum = 1;
    if (!value) {
      this.testQuestionsister = new TestQuestion();
      this.$store.state.testQuestion.editSisterQuestion = this.testQuestionsister;
      (this.$refs.sisterQuestionForm as any).resetFields();
      if (this.isCreate) this.$emit("save-success");
      this.$emit("input", value);
    } else {
      this.data = this.$store.state.testQuestion.cascaders.items;
      this.testQuestionsister = Util.extend(
        true,
        {},
        this.$store.state.testQuestion.editSisterQuestion,
      );
      this.valueArray = this.testQuestionsister.categoryList;
      if (this.testQuestionsister.id) {
        this.isCreate = false;
        this.formTitle = "修改姊妹题";
        this.keytype = this.testQuestionsister.correctAnswer;
        this.keychecktype = this.testQuestionsister.listAnswer;
        this.onequestype = this.testQuestionsister.correctAnswer;
        this.questionContentsister = this.testQuestionsister.questionContent;
        this.answerTipssister = this.testQuestionsister.answerTips;
        this.testQuestionsister.isAudit = this.testQuestionsister.isAudit.toString();
        // this.setEditorData_a();
        // this.setEditorData_g();
        if (this.testQuestionsister.questionType > 0) {
          if (this.testQuestionsister.answerKeyA === null) {
            this.answerKeyAsister = "";
          } else {
            this.answerKeyAsister = this.testQuestionsister.answerKeyA;
          }
          if (this.testQuestionsister.answerKeyB === null) {
            this.answerKeyBsister = "";
          } else {
            this.answerKeyBsister = this.testQuestionsister.answerKeyB;
          }
          if (this.testQuestionsister.answerKeyC === null) {
            this.answerKeyCsister = "";
          } else {
            this.answerKeyCsister = this.testQuestionsister.answerKeyC;
          }
          if (this.testQuestionsister.answerKeyD === null) {
            this.answerKeyDsister = "";
          } else {
            this.answerKeyDsister = this.testQuestionsister.answerKeyD;
          }
          if (this.testQuestionsister.answerKeyE === null) {
            this.answerKeyEsister = "";
          } else {
            this.answerKeyEsister = this.testQuestionsister.answerKeyE;
          }
          //试题为单选或者填空时编辑器内容赋值
          if (
            this.testQuestionsister.questionType == 1 ||
            this.testQuestionsister.questionType == 3
          ) {
            if (
              this.testQuestionsister.answerKeyF === null ||
              !this.testQuestionsister.answerKeyF
            ) {
              this.answerKeyFsister = "";
            } else {
              this.answerKeyFsister = this.testQuestionsister.answerKeyF;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestionsister.answerKeyG === null ||
              !this.testQuestionsister.answerKeyG
            ) {
              this.answerKeyGsister = "";
            } else {
              this.answerKeyGsister = this.testQuestionsister.answerKeyG;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestionsister.answerKeyH === null ||
              !this.testQuestionsister.answerKeyH
            ) {
              this.answerKeyHsister = "";
            } else {
              this.answerKeyHsister = this.testQuestionsister.answerKeyH;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestionsister.answerKeyI === null ||
              !this.testQuestionsister.answerKeyI
            ) {
              this.answerKeyIsister = "";
            } else {
              this.answerKeyIsister = this.testQuestionsister.answerKeyI;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
            if (
              this.testQuestionsister.answerKeyJ === null ||
              !this.testQuestionsister.answerKeyJ
            ) {
              this.answerKeyJsister = "";
            } else {
              this.answerKeyJsister = this.testQuestionsister.answerKeyJ;
              this.choicenum = 2;
              this.blanksnum = 2;
            }
          }
          if (this.testQuestionsister.questionType == 3) {
            if (
              this.testQuestionsister.answerKeyK === null ||
              !this.testQuestionsister.answerKeyK
            ) {
              this.answerKeyKsister = "";
            } else {
              this.answerKeyKsister = this.testQuestionsister.answerKeyK;
              this.blanksnum = 3;
            }
            if (
              this.testQuestionsister.answerKeyL === null ||
              !this.testQuestionsister.answerKeyL
            ) {
              this.answerKeyLsister = "";
            } else {
              this.answerKeyLsister = this.testQuestionsister.answerKeyL;
              this.blanksnum = 3;
            }
            if (
              this.testQuestionsister.answerKeyM === null ||
              !this.testQuestionsister.answerKeyM
            ) {
              this.answerKeyMsister = "";
            } else {
              this.answerKeyMsister = this.testQuestionsister.answerKeyM;
              this.blanksnum = 3;
            }
            if (
              this.testQuestionsister.answerKeyN === null ||
              !this.testQuestionsister.answerKeyN
            ) {
              this.answerKeyNsister = "";
            } else {
              this.answerKeyNsister = this.testQuestionsister.answerKeyN;
              this.blanksnum = 3;
            }
            if (
              this.testQuestionsister.answerKeyO === null ||
              !this.testQuestionsister.answerKeyO
            ) {
              this.answerKeyOsister = "";
            } else {
              this.answerKeyOsister = this.testQuestionsister.answerKeyO;
              this.blanksnum = 3;
            }
          }
          // this.setEditorData_b();
          // this.setEditorData_c();
          // this.setEditorData_d();
          // this.setEditorData_e();
          // this.setEditorData_f();
        }
      } else {
        this.isCreate = true;
        this.formTitle = "增加姊妹题";
        this.createInit();
        //this.setEditorDataInit();
      }
    }
  }
  createInit() {
    //(this.$refs.sisterQuestionForm as any).resetFields();
    if (this.testQuestionsister.sisterId === "") this.valueArray = [];
    this.keytype = "";
    this.keychecktype = [];
  }
}
